






























































































































































































































































































































































































































































































































































































































import { Component, Mixins, Watch } from "vue-property-decorator";
import Api from "@/api";
import FormErrorsMixin from "@/mixins/FormErrors";
import swal from "sweetalert";

import ViewLoader from "@/components/Common/ViewLoader.vue";
import NavigationTabs from "@/components/Settings/Operator/NavigationTabs.vue";
import TextInput from "@/components/Common/Inputs/TextInput.vue";
import FieldsetButton from "@/components/Common/Buttons/FieldsetButton.vue";
import Error404 from "@/components/Common/Error404.vue";
import { Gender, ICountry, ICountryState, IOperator } from "@/interface";
import { AxiosResponse } from "axios";

Component.registerHooks(["beforeRouteEnter", "beforeRouteUpdate"]);

@Component({
  components: {
    ViewLoader,
    NavigationTabs,
    TextInput,
    FieldsetButton,
    Error404
  }
})
export default class OperatorGeneralSettings extends Mixins(FormErrorsMixin) {
  public loading = false;
  public updating = false;
  public validatedInputs = [
    "name",
    "email",
    "website",
    "fiscal_details.uid",
    "fiscal_details.fn",
    "fiscal_details.zvr",
    "fiscal_details.dvr",
    "phone_number.prefix",
    "phone_number.number",
    "fax_number.prefix",
    "fax_number.number",
    "contact_person.first_name",
    "contact_person.last_name",
    "contact_person.email",
    "contact_person.phone_number.last_name",
    "contact_person.phone_number.prefix",
    "contact_person.phone_number.number",
    "address.country_id",
    "address.state_id",
    "address.city",
    "address.post_code",
    "address.street_name",
    "address.street_number",
    "address.additional_information"
  ];
  private operators: Array<IOperator> = [];
  private noDataExist = false;
  private selectedOperator: IOperator | null = null;
  private selectedOperatorId: string | null = null;
  private countries: Array<ICountry> = [];

  private beforeRouteEnter(to: any, from: any, next: any): void {
    next((vm: this) => {
      vm.selectedOperatorId = vm.$route.params.id;
      vm.getOperators(() => {
        vm.getOperator(() => {
          vm.getCountries();
        });
      });
    });
  }

  private beforeRouteUpdate(to: any, from: any, next: any): void {
    this.getOperators(() => {
      this.getOperator(() => {
        this.getCountries();
      });
    });
    next();
  }

  private setGender(gender: Gender): void {
    if (this.selectedOperator && this.selectedOperator.contact_person)
      this.selectedOperator.contact_person.gender = gender;
  }

  private createOperator(): void {
    const endpoint: string = this.$partnerEndpoint("operators");

    Api()
      .post(endpoint)
      .then((response: AxiosResponse) => {
        this.selectedOperatorId = response.data.data.id;
      })
      .catch((error: any) => {
        console.log(error);
      });
  }

  private getOperators(successCallback?: any): void {
    this.loading = true;
    const endpoint: string = this.$partnerEndpoint("operators");

    Api()
      .get(endpoint, {
        params: {
          page: 1,
          search: ""
        }
      })
      .then((response: AxiosResponse) => {
        this.operators = response.data.data || "undefined";
        if (typeof successCallback == "function") {
          successCallback();
        }
      })
      .catch((error: any) => {
        console.log(error);
      });
  }

  private getOperator(successCallback?: any): void {
    this.loading = true;
    const endpoint: string = this.$partnerEndpoint(
      "operators/" + this.selectedOperatorId
    );

    Api()
      .get(endpoint)
      .then((response: AxiosResponse) => {
        this.selectedOperator = response.data.data;

        if (typeof successCallback == "function") {
          successCallback();
        }
      })
      .catch((error: any) => {
        if (error.response.status === 404) {
          this.noDataExist = true;
        }
        this.storeErrors(error.response.data.errors);
      })
      .finally(() => {
        this.loading = false;
      });
  }

  private updateOperator(): void {
    this.resetErrors();
    const endpoint: string = this.$partnerEndpoint(
      "operators/" + this.selectedOperatorId
    );

    Api()
      .put(endpoint, this.selectedOperator)
      .then(() => {
        this.getOperators(() => {
          this.getOperator(() => {
            swal({
              title: "Success!",
              text: "The operator was updated.",
              icon: "success"
            });
          });
        });
      })
      .catch((error: any) => {
        this.storeErrors(error.response.data.errors);
        this.$scrollTo("#operator-email", 500);
      });
  }

  private deleteOperator(): void {
    if (this.loading || this.updating) {
      return;
    }

    swal({
      title: "Are you sure?",
      text: "The operator will be deleted",
      icon: "warning",
      dangerMode: true,
      buttons: {
        cancel: {
          visible: true,
          text: "Cancel",
          closeModal: true
        },
        confirm: {
          visible: true,
          text: "Yes, delete it!",
          closeModal: true
        }
      }
    }).then(isConfirm => {
      if (isConfirm) {
        const endpoint: string = this.$partnerEndpoint(
          "operators/" + this.selectedOperatorId
        );

        Api()
          .delete(endpoint)
          .then(() => {
            this.$router.push({
              name: "OperatorGeneralSettings",
              params: { id: "default" }
            });
          })
          .catch((error: any) => {
            if (error.response.status === 403) {
              swal({
                title: "Missing permission",
                text: "You are not allowed to delete operators.",
                icon: "error"
                //dangerMode: true,
              });
            }
          });
      } else {
        //
      }
    });
  }

  private getCountries(successCallback?: any): void {
    Api()
      .get("api/internal/v1/countries")
      .then((response: AxiosResponse) => {
        this.countries = response.data.data;

        if (typeof successCallback == "function") {
          successCallback();
        }
      })
      .catch((error: any) => {
        console.log(error);
      });
  }

  private countryShouldBeSelected(country: ICountry): boolean {
    return (
      this.selectedOperator !== null &&
      this.selectedOperator.address !== undefined &&
      this.selectedOperator.address.country_id == country.id
    );
  }

  private stateShouldBeSelected(state: ICountryState): boolean {
    return (
      this.selectedOperator !== null &&
      this.selectedOperator.address !== undefined &&
      this.selectedOperator.address.state_id == state.id
    );
  }

  get isFemale(): boolean {
    return (
      this.selectedOperator !== null &&
      this.selectedOperator.contact_person !== undefined &&
      this.selectedOperator.contact_person.gender == 2
    );
  }

  get isMale(): boolean {
    return (
      this.selectedOperator !== null &&
      this.selectedOperator.contact_person !== undefined &&
      this.selectedOperator.contact_person.gender == 1
    );
  }

  get operatorName(): string {
    if (typeof this.operators == "undefined") {
      return "";
    }

    if (
      this.selectedOperatorId === "default" &&
      this.selectedOperator &&
      this.selectedOperator.name
    ) {
      return this.selectedOperator.name;
    }

    for (var i = 0; i < this.operators.length; i++) {
      if (this.operators[i].id == this.selectedOperatorId) {
        return this.operators[i].name || "";
      }
    }

    return "";
  }

  get statesOfSelectedCountry(): Array<ICountryState> {
    for (var i = 0; i < this.countries.length; i++) {
      if (
        this.selectedOperator !== null &&
        this.selectedOperator.address !== undefined &&
        this.countries[i].id != this.selectedOperator.address.country_id
      ) {
        continue;
      }
      return this.countries[i].states || [];
    }

    return [];
  }

  @Watch("selectedOperatorId")
  selectedOperatorIdChanged(selectedOperatorId: string): void {
    this.$router.push({
      name: "OperatorGeneralSettings",
      params: { id: `${selectedOperatorId}` }
    });
  }
}
